// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-age-2 .age-description {
  padding: 12px;
  background-color: white;
  border: 1px solid var(--gray);
  border-radius: 8px;
  max-width: 264px;
  margin: 16px auto;
}
`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/pages/age-2.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":[".page-age-2 .age-description {\n  padding: 12px;\n  background-color: white;\n  border: 1px solid var(--gray);\n  border-radius: 8px;\n  max-width: 264px;\n  margin: 16px auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
